import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "12",
  height: "12",
  fill: "none"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      fill: "currentColor",
      d: "M0 5.898c0 .162.071.31.2.433l4.291 4.285c.13.122.265.18.42.18a.55.55 0 0 0 .569-.555.57.57 0 0 0-.162-.407L3.871 8.36 1.31 6.027l-.135.317 2.08.13h8.175c.336 0 .569-.24.569-.576s-.233-.575-.569-.575H3.257l-2.08.13.135.322L3.87 3.436l1.447-1.473a.58.58 0 0 0 .162-.407A.55.55 0 0 0 4.91 1a.58.58 0 0 0-.433.194L.2 5.465a.6.6 0 0 0-.2.433"
    }, null, -1)
  ])))
}
export default { render: render }